import apiClient from "./apiService";

export default {
  async getReportsListing(params?: {
    name?: string;
    round?: number;
    status?: number;
    page?: number;
  }) {
    const response = await apiClient.get("/reports", { params });
    return response.data;
  },

  async downloadReports({
    reportIds,
    language,
  }: {
    reportIds: number[];
    language: string;
  }) {
    const formData = new FormData();
    formData.append("language", language);

    reportIds.forEach((id: number) => {
      formData.append("report_ids[]", id.toString());
    });

    // Return full response, including headers
    return apiClient.post("/reports/download", formData, {
      responseType: "blob", // Required for file downloads
    });
  },

  async viewSingleReport(reportId: number, lang: string) {
    return apiClient.get(`/reports/${reportId}/view-pdf`, {
      params: { lang },
      responseType: "blob", // important for PDF
    });
  },

  async getWebReportResults({
    schoolIds,
    academicYears,
    roundIds,
    gradeIds,
    platformId,
    showComparative,
  }: {
    schoolIds: number[];
    academicYears: number[];
    roundIds: number[];
    gradeIds: number[];
    platformId: number;
    showComparative?: boolean;
  }) {
    const params = new URLSearchParams();

    schoolIds.forEach((id) => params.append("school_id[]", id.toString()));
    academicYears.forEach((year) =>
      params.append("academic_year_id[]", year.toString())
    );
    roundIds.forEach((round) => params.append("round_id[]", round.toString()));
    gradeIds.forEach((grade) => params.append("grade_id[]", grade.toString()));
    params.append("platform_id", platformId.toString());
    params.append("show_comparative", showComparative ? "1" : "0");

    const response = await apiClient.get(
      `/web-report/results?${params.toString()}`
    );
    return response.data;
  },

  async getDynamicFiltersQS(paramsQS?: URLSearchParams) {
    return apiClient.get(`/web-report/filters?${paramsQS?.toString() || ""}`);
  },
};
